export default __webpack_public_path__ + "static/media/Gauntlets of Indomitable Souls.514d46aa.jpg";